import { Component, Input } from '@angular/core';

@Component({
  selector: 'custom-radio-button',
  templateUrl: './custom-radio-button.component.html'
})
export class CustomRadioButtonComponent {
  @Input() options: any[] = []
  @Input() ngModel: any;


}
